// import { movies } from "./getMovies";
import "./Banner.css"
import React, { Component } from 'react'
// var url = require("url")
import axios from "axios"


export default class Banner extends Component {
  constructor(){
    super()
    this.state={
      movies:[]
    }
  }
  async componentDidMount(){
    // console.log("side effect");
    const res = await axios.get("https://api.themoviedb.org/3/trending/all/day?api_key=6bac6e7f2d97716fb0a7d0d2a666c80f")
    let data = res.data
    // console.log([...data.results][0],"ko");
    this.setState({
      movies:[...data.results][0]
    })
    //  console.log(this.state.movies);
  }
  render() {
    // let movie = movies.results[0]
    // console.log("render banner");
    return (
      <>
      {
        this.state.movies.length === 0?
        <div className="border border-blue-300 shadow rounded-md m-2 p-4 max-w-sm w-full mx-auto">
          <div className="animate-pulse flex space-x-4">
            <div className="rounded-full bg-slate-700 h-10 w-10"></div>
            <div className="flex-1 space-y-6 py-1">
              <div className="h-2 bg-slate-700 rounded"></div>
              <div className="space-y-3">
                <div className="grid grid-cols-3 gap-4">
                  <div className="h-2 bg-slate-700 rounded col-span-2"></div>
                  <div className="h-2 bg-slate-700 rounded col-span-1"></div>
                </div>
                <div className="h-2 bg-slate-700 rounded"></div>
              </div>
            </div>
          </div>
        </div>:
      <>
      {/* <img className ="sm:h-[70vh] h-[50vh]" style={{width:"100vw"}} src={`https://image.tmdb.org/t/p/original/${this.state.movies.backdrop_path}`} alt="img"/> */}
      <div className ="sm:h-[70vh]  h-[40vh] bg-contain bg-no-repeat bg-center" style={{width:"100%",backgroundImage: `url("https://image.tmdb.org/t/p/original/${this.state.movies.backdrop_path}")`,backgroundSize:"100% 100%"}} ></div>  
      <div className="banner-head bg-gray-900 bg-opacity-40">
      <div className="
      text-white
      text-2xl
      font-bold
      text-center
      ">{this.state.movies.original_title||this.state.movies.name}</div>
      <p className="h-24 sm:text-base text-center text-xs md:px-4 px-2 text-white overflow-hidden">{this.state.movies.overview}</p>
      </div>
      </>
      }
      </>
      
    )
  }
}
